import { baseRoutes } from "@base/routes/baseRoutes";
import { useState } from "react";
import authService from "../authService";
import { clearSession } from "../session";

const useLogout = () => {
  const [isLoading, setLoading] = useState(false);

  const handleLogout = async () => {
    if (isLoading) {
      return;
    }

    setLoading(true);

    try {
      // Best effort: revoke server-side while the access token is still valid.
      await authService.logout();
    } catch (_error) {
      // A failing call must not leave the user signed in on this device.
    }

    // No setLoading(false): clearSession navigates away and the page reloads.
    clearSession(baseRoutes.home);
  };

  return {
    isLoading,
    handleLogout,
  };
};

export default useLogout;
